import { ItemEditForm } from './editModal';

export const emptyItemForm = (): ItemEditForm => ({
  item_name: '',
  furigana: '',
  category_id: '',
  level: '',
});

export const itemLevelLabel = (level: number | null | undefined): string => {
  if (level === 1) {
    return 'LIGHT';
  }
  if (level === 2) {
    return 'その他';
  }
  if (level == null) {
    return '-';
  }
  return String(level);
};

export const parseItemForm = (
  form: ItemEditForm
): { item_name: string; furigana: string | null; category_id: number; level: number | null } | null => {
  if (!form.item_name.trim()) {
    alert('商品名を入力してください。');
    return null;
  }
  if (!form.category_id) {
    alert('カテゴリを選択してください。');
    return null;
  }

  const levelValue = form.level.trim();
  if (levelValue !== '' && levelValue !== '1' && levelValue !== '2') {
    alert('レベルは LIGHT または その他 を選択してください。');
    return null;
  }

  return {
    item_name: form.item_name.trim(),
    furigana: form.furigana.trim() || null,
    category_id: Number(form.category_id),
    level: levelValue === '' ? null : Number(levelValue),
  };
};
